<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M14.729 2.666V25.45c-6.292 0-11.392-5.1-11.392-11.392s5.1-11.392 11.392-11.392zm2.589 26.667c5.765 0 10.53-4.282 11.287-9.838H17.318v9.838zm0-12.427h11.346C28.14 11.1 23.26 6.549 17.318 6.549v10.357z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'brandCronospainel'
}
</script>
